import { WebFormQuestionTableFieldFragment$key } from "@/web-form/table/__generated__/WebFormQuestionTableFieldFragment.graphql"
import DiscoEditor from "@components/editor/DiscoEditor"
import { TestIDProps } from "@utils/typeUtils"
import { graphql, useFragment } from "react-relay"

interface Props extends TestIDProps {
  webFormQuestionKey: WebFormQuestionTableFieldFragment$key
}

function WebFormQuestionTableField({ testid, webFormQuestionKey }: Props) {
  const webFormQuestion = useFragment<WebFormQuestionTableFieldFragment$key>(
    graphql`
      fragment WebFormQuestionTableFieldFragment on WebFormQuestion {
        richEditorBody
      }
    `,
    webFormQuestionKey
  )

  return (
    <DiscoEditor
      testid={testid}
      defaultValue={webFormQuestion.richEditorBody}
      disableGutter
      readOnly
      backgroundColor={"transparent"}
    />
  )
}

export default WebFormQuestionTableField
